import isFQDN from 'validator/lib/isFQDN';

export const validateRecipeDomainName = (data, recipeName) => {
  const validDomain = new RegExp(/^(?!https?:\/\/).*(\.[a-zA-Z0-9-].*)/);
  const oneDomain = new RegExp(/^[^;,\s]+$/);
  const wildcards = new RegExp(/^[^*\s]+$/);
  const specialChars = new RegExp(/^[0-9a-z.:/_\*-\s\[\]]+$/);
  const errorMessage =
    recipeName === 'Brand Impersonation'
      ? 'Please enter either a valid domain name or regex!'
      : 'Please enter a valid domain name.';

  if (data) {
    let sanitizedData = data
      ?.replaceAll('[', '')
      ?.replaceAll(']', '')
      ?.trim()
      ?.replaceAll(' ', '')
      ?.replaceAll('./', '.');

    if (sanitizedData?.toString()?.startsWith('http://')) {
      sanitizedData = sanitizedData?.replace('http://', '');
    }
    if (sanitizedData?.toString()?.startsWith('https://')) {
      sanitizedData = sanitizedData?.replace('https://', '');
    }
    if (sanitizedData?.toString()?.startsWith('www')) {
      sanitizedData = sanitizedData?.replace('www.', '');
    }

    if (!wildcards.test(sanitizedData)) {
      return { valid: false, message: 'Wildcards are not allowed.' };
    }
    if (!validDomain.test(sanitizedData)) {
      return { valid: false, message: errorMessage };
    }
    if (!oneDomain.test(sanitizedData)) {
      return { valid: false, message: 'Please enter only one domain.' };
    }
    if (!specialChars.test(sanitizedData)) {
      return { valid: false, message: errorMessage };
    }

    if (!isFQDN(sanitizedData)) {
      return { valid: false, message: errorMessage };
    } else {
      return { valid: true };
    }
  } else {
    return { valid: false, message: errorMessage };
  }
};
